import React, { useState, useEffect } from 'react';
import { getSinglePackage, } from "../../../ReduxStore/Slice/Pricing/PackageSlice";
import { useDispatch } from 'react-redux';
import Datatable from '../../../ExtraComponents/ReusableTable1';
import { PencilLine, Trash2 } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import Swal from 'sweetalert2';
import { StripHtmlAndTruncate } from "../../../Utils/CommonFun";


const History = () => {

    
    const dispatch = useDispatch();
    const location = useLocation();
    const agent_id = JSON.parse(localStorage.getItem("agent_id"));
    const token = localStorage.getItem("token");
    const [getServiceData, setServiceData] = useState([]);

    // console.log("getServiceData", getServiceData);

    useEffect(() => {
        viewService()
    }, []);

    const viewService = async () => {
        setServiceData(location?.state?.ServiceHistories || [])
    };

    const DateFarmet = (newDate) => {
        const date = new Date(newDate);
        const formattedDate = format(date, 'eee, MMM d, yyyy h:mm a');
        return formattedDate;
    }


    const columns = [
        {
            name: "History",
            cell: (row) => (
                <>
                    <div>
                        <p>
                            {row.history}
                        </p>
                        <p>
                            {DateFarmet(row?.createdAt)}
                        </p>
                    </div>

                </>
            ),
            selector: (row) => row.history,
            sortable: true,
        },
        {
            name: "Description",
            cell: (row) => {
                const { truncated, isTruncated, fullText } = StripHtmlAndTruncate(row?.description || "");
                return (
                    <div>
                        {truncated}
                        {isTruncated && (
                            <span 
                                className="text-pink cursor-pointer ms-1" 
                                onClick={() => {
                                    Swal.fire({
                                        title: 'Full Description',
                                        text: fullText,
                                        confirmButtonColor: '#ff00a2'
                                    });
                                }}
                                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                            >
                                Read More
                            </span>
                        )}
                    </div>
                );
            },
            selector: (row) => row.description,
            sortable: true,
        },

    ];

    return (
        <div>
            <section className="section dashboard">
                <div className="row">
                    <div className='dark-table-thead'>
                        <Datatable
                            columns={columns}
                            data={getServiceData && getServiceData || []}
                            filter={false}
                        />
                    </div>
                </div>
            </section>

        </div>
    );
};

export default History;
